"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instance = void 0;
var expression_1 = require("./expression");
var quantity_1 = require("../datatypes/quantity");
var datatypes_1 = require("../datatypes/datatypes");
var builder_1 = require("./builder");
var Element = /** @class */ (function () {
    function Element(json) {
        this.name = json.name;
        this.value = (0, builder_1.build)(json.value);
    }
    Element.prototype.exec = function (ctx) {
        return this.value != null ? this.value.execute(ctx) : undefined;
    };
    return Element;
}());
var Instance = /** @class */ (function (_super) {
    __extends(Instance, _super);
    function Instance(json) {
        var _this = _super.call(this, json) || this;
        _this.classType = json.classType;
        _this.element = json.element.map(function (child) { return new Element(child); });
        return _this;
    }
    Instance.prototype.exec = function (ctx) {
        var obj = {};
        for (var _i = 0, _a = this.element; _i < _a.length; _i++) {
            var el = _a[_i];
            obj[el.name] = el.exec(ctx);
        }
        switch (this.classType) {
            case '{urn:hl7-org:elm-types:r1}Quantity':
                return new quantity_1.Quantity(obj.value, obj.unit);
            case '{urn:hl7-org:elm-types:r1}Code':
                return new datatypes_1.Code(obj.code, obj.system, obj.version, obj.display);
            case '{urn:hl7-org:elm-types:r1}Concept':
                return new datatypes_1.Concept(obj.codes, obj.display);
            default:
                return obj;
        }
    };
    return Instance;
}(expression_1.Expression));
exports.Instance = Instance;
//# sourceMappingURL=instance.js.map